
import requestAPI from '@/logic/requestBeApi';
import config from '@/config';
import { getLocaleString } from '@/logic/requestBeApi';
import ImageCropper from '@/components/ImageCropper.vue';
import b64toBlob from '@/logic/b64toBlob';

export default {
  components: {
    ImageCropper,
  },

  props: {
    profileCompletionPercentage: {
      type: Number,
      default: 0,
    },
  },
  data(): Record<string, unknown> {
    return {
      loading: false,
      imageUrl: '',
      headers: {
        Accept: 'application/json, text/plain, */*',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      imageId: '',
      imageToCrop: '',
      cropperActive: false,
    };
  },

  computed: {
    profilePictureEndpoint(): string {
      return `${config.BE_URL}/api/v1/profile-pictures` + (this.imageId ? `/${this.imageId}` : '');
    },
  },

  created(): void {
    this.getAvatar();
  },

  methods: {
    async getAvatar(): Promise<void> {
      const resp = await requestAPI({
        url: '/api/v1/assessors/me/profile-picture',
        method: 'GET',
      });

      if (resp.ok) {
        const data = await resp.json();
        this.imageUrl = data.url;
        this.imageId = data.id;
      }
    },

    handleAvatarError(): void {
      this.loading = false;
      this.$message.error(this.$t('someErrorOccurredAvatar'));
    },

    beforeAvatarUpload(file: { size: number }): boolean {
      if (!file) return false;

      if (file.size >= 2_000_000) {
        this.$message({
          showClose: true,
          message: this.$t('imageTooBig'),
          type: 'warning',
          duration: 10000,
        });

        return false;
      }

      this.imageToCrop = URL.createObjectURL(file);
      this.cropperActive = true;

      return false;
    },

    getUrl(): string {
      return `${config.BE_URL}/api/v1/profile-pictures`;
    },

    async uploadAvatar(): Promise<void> {
      if (!this.file) {
        this.$message.error(this.$t('someErrorOccurredAvatar'));
        return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append('profile_picture', this.file);

      const headers = {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'X-LOCALE': getLocaleString(),
      };

      if (config.isOnDevEnv) delete headers['X-LOCALE'];

      const resp = await fetch(this.profilePictureEndpoint, {
        method: this.imageId ? 'PUT' : 'POST',
        headers,
        body: formData,
      });

      if (resp.ok) {
        this.$message.success(this.$t('yourAvatarHasBeenUploaded'));

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else this.$message.error(this.$t('someErrorOccurredAvatar'));

      this.loading = false;
    },

    getCroppedImage(payload: string): void {
      this.file = b64toBlob(payload, 'image');
      this.cropperActive = false;

      this.uploadAvatar();
    },

    triggerUpload(): void {
      this.cropperActive = false;

      (document.querySelector(
        '.avatar-uploader .el-upload .el-upload__input',
      ) as HTMLElement).click();
    },
  },
};
